import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "truncate w-full"
}
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-500 font-medium"
}


	const __default__ = { name: 'SimpleStat' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: { 
		badge: {
			type: Boolean,
			default: false
		},
		editing: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		labelClass: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: '—'
		},
		value: {
			type: [ String, Number ],
			default: null
		},
		valueClass: {
			type: String,
			default: ''
		},
		unit: {
			type: String,
			default: ''
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dt", {
      class: _normalizeClass([__props.labelClass, 'truncate text-sm font-medium text-gray-500'])
    }, _toDisplayString(props.label), 3),
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.$slots.custom)
        ? (_openBlock(), _createElementBlock("dd", _hoisted_1, [
            _renderSlot(_ctx.$slots, "custom")
          ]))
        : (_openBlock(), _createElementBlock("dd", {
            key: 1,
            class: _normalizeClass([__props.valueClass, 'mt-1 text-3xl font-semibold tracking-tight text-gray-900 flex items-baseline gap-x-2'])
          }, [
            _renderSlot(_ctx.$slots, "default"),
            (__props.unit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.unit), 1))
              : _createCommentVNode("", true)
          ], 2))
    ], 512), [
      [_vShow, !__props.loading]
    ]),
    _withDirectives(_createElementVNode("div", null, _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "mt-6 h-4 rounded-full bg-gray-300 animate-pulse w-full" }, null, -1)
    ]), 512), [
      [_vShow, __props.loading]
    ])
  ], 64))
}
}

})